import React, { useState, useEffect} from 'react';
import axios from 'axios';
import constant from '../Constants/constants';
import Loading from '../Components/Loading/Loading'

// holds application context (business context)
// this should be loaded only once
const initialState = {
    loading: false,
    questions: [],
    restartQuiz: false,
    disableOptions:false,
    formData: {
        firstName: '',
        lastName: '',
        businessName: '',
        address1: '',
        address2: '',
        city: '',
        province: '',
        postalCode: '',
        email: '',
        phone: '',
        contactCode:'',
        acceptTAndC: false,
        acceptCEM: false,
        campaignId: 4,
        source:'Contest Website'
    },
    products: {
        smoulder: {
            name: "Smoulder",
            productLogo: "/preseedherbicide/images/Smoulder_R.svg",
            headline: "A burndown broadleaf weeds can’t resist.",
            heading: "Start the season without broadleaf weeds when you apply Smoulder<sup>®</sup> herbicide pre-seed.",
            slideImages: ["/preseedherbicide/images/certitude.jpeg", "/preseedherbicide/images/smoulder.jpeg", "/preseedherbicide/images/voraxor.jpeg"],
            videoURL: "f7g_nIHhuUk",

            learnMore: "Visit the product page below to see what kind of heat Smoulder is bringing to the field.",
            pageLink: "https://agriculture.basf.ca/west/products/solutions/smouldertm.html",
            cropImage: "/preseedherbicide/images/CEREALS_13_summer_38074@2x.png",
            cropImageAlt: "wheat growing in a field",

            tableContents: [
                {
                    title: "Group 14",
                    text: "Increased activity on broadleaf weeds."
                },
                {
                    title: "Enhanced residual",
                    text: "Activity on tough-to-control weeds including cleavers, kochia and wild mustard."
                },
                {
                    title: "Tirexor",
                    text: "Contains innovative new active ingredient."
                },
            ],

            treated: ["/preseedherbicide/images/Smoulder residual activity - Smoulder.png", "Treated with smoulder, a weed with few weeds"],
            untreated: ["/preseedherbicide/images/Smoulder residual activity - Untreated.png", "Untreated, a field full of weeds"],

            imageRowContents: [
                [
                    {
                        image_src: "/preseedherbicide/images/Smoulder-2.png",
                        image_alt: "N/A",
                        text: ""
                    },
                ],
            ]

        },
        voraxor: {
            name: "Voraxor",
            productLogo: "/preseedherbicide/images/Voraxor_R.svg",
            headline: "Wipe fields clean for your pulses.",
            heading: "Voraxor<sup>®</sup> herbicide provides high performance, broad-spectrum pre-seed burndown with consistent residual activity in peas, lentils and soybeans.",
            slideImages: ["/preseedherbicide/images/certitude.jpeg", "/preseedherbicide/images/smoulder.jpeg", "/preseedherbicide/images/voraxor.jpeg"],
            videoURL: "lBRNUR93iWc",

            learnMore: "See how Voraxor raises pulses and lowers weeds at the product page below.",
            pageLink: "https://agriculture.basf.ca/west/products/solutions/voraxortm.html",
            cropImage: "/preseedherbicide/images/LENTILS_AdobeStock_267814752@2x.png",
            cropImageAlt: "lentil plant",

            tableContents: [
                {
                    title: "Post-emergence burndown",
                    text: "Control of emerged weeds."
                },
                {
                    title: "Pre-emergence residual",
                    text: "Residual pre-emergence control of secondary flushes of volunteer canola."
                },
                {
                    title: "Resistant kochia control",
                    text: "Burndown control of Group 2-, 4- and 9-resistant kochia."
                },
            ],

            treated: ["/preseedherbicide/images/voraxor_1.png", "voraxor vs competitors. Voraxor treated field containing less weeds than a GoldWing treated field which contains less weeds than an Aim EC herbicide treated field"],
            untreated: ["", ""],

            imageRowContents: [
                [
                    {
                        image_src: "/preseedherbicide/images/voraxor_2.png",
                        image_alt: "",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/voraxor_3.png",
                        image_alt: "",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/voraxor_4.png",
                        image_alt: "",
                        text: ""
                    },
                ],
            ]
        },
        certitude: {
            name: "Certitude",
            productLogo: "/preseedherbicide/images/Certitude.svg",
            headline: "New mode of action.<br/>New level of certainty.",
            heading: "Certitude<sup>®</sup> herbicide combines the pre-seed industry-first Group 27 chemistry with Group 6 chemistry to provide exceptional weed control and enhanced sustainability to your canola fields.",
            slideImages: ["/preseedherbicide/images/certitude.jpeg", "/preseedherbicide/images/smoulder.jpeg", "/preseedherbicide/images/voraxor.jpeg"],
            videoURL: "7QRqfw2JZXI",

            learnMore: "See what a little ‘tude can do for your fields by visiting the Certitude product page.",
            pageLink: "https://agriculture.basf.ca/west/products/solutions/certitude.html",
            cropImage: "/preseedherbicide/images/CANOLA_DSC_6615@2x.png",
            cropImageAlt: "multiple weeds growing in a field",

            tableContents: [
                {
                    title: "Consistent control",
                    text: "Both contact and systemic activity."
                },
                {
                    title: "Group 27",
                    text: "New mode of pre-seed action helps improve sustainability."
                },
                {
                    title: "First of its kind",
                    text: "Industry-first Group 27 chemistry for pre-seed in canola production."
                },
                {
                    title: "Kochia control",
                    text: "Exceptional control of kochia, including resistant biotypes."
                },
                {
                    title: "Volunteer canola control",
                    text: "Effectively controls herbicide-resistant volunteers."
                },
                {
                    title: "Group 6",
                    text: "Chemistry controls a variety of broadleaf weeds."
                },
            ],

            treated: ["/preseedherbicide/images/Certitude_kochia_Certitude.png", "Treated with cirtitude, a weed with few weeds"],
            untreated: ["/preseedherbicide/images/Certitude_kochia_Untreated.png", "Untreated, a field full of weeds"],

            imageRowContents: [
                [
                    {
                        image_src: "/preseedherbicide/images/Certitude_kochia_Certitude.png",
                        image_alt: "N/A",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/Certitude_kochia_Conquer.png",
                        image_alt: "N/A",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/Certitude_kochia_Untreated.png",
                        image_alt: "N/A",
                        text: ""
                    },
                ],
                [
                    {
                        image_src: "/preseedherbicide/images/Certitude_volunteer_canola_Certitude.png",
                        image_alt: "N/A",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/Certitude_volunteer_canola_Conquer_II.png",
                        image_alt: "N/A",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/Certitude_volunteer_canola_Prospect.png",
                        image_alt: "N/A",
                        text: ""
                    },
                    {
                        image_src: "/preseedherbicide/images/Certitude_volunteer_canola_Untreated.png",
                        image_alt: "N/A",
                        text: ""
                    },
                ],
            ]
        }
    },

    pageBox2: [
        {
            heading: "Pre-seed herbicide benefits.",
            description: "Weeds present at the critical growth stages of your crop steal precious resources such as moisture and nutrients. Controlling these weeds eliminates this competition to help maximize the yield potential of your crop, protect your return on investment and can help manage herbicide resistance.",
            buttonLabel: "Learn More",
            buttonLink: "/preseedherbicide",
            showTC: "false",

            cropImage: "/preseedherbicide/images/CANOLA_DSC_6615@2x.png",
            cropImageAlt: "multiple weeds growing in a field"
        },


    ],
    pageBox3: [
        {
            heading: "Certitude herbicide",
            description: "Certitude<sup>®</sup> herbicide combines its Group 6 and Group 27 chemistries to bring your fields powerful weed control and sustainability you can count on.",
            buttonLabel: "Learn More",
            buttonLink: "/certitude",
            productLogo: "/preseedherbicide/images/Certitude.svg",
            productIcons:
                [
                    ["/preseedherbicide/images/Group_382.png", "Canola"],
                ],

            cropImage: "/preseedherbicide/images/CANOLA_DSC_6615.png",
            cropImageAlt: "multiple weeds growing in a field"
        },
        {
            heading: "Smoulder herbicide",
            description: "With Smoulder<sup>®</sup> herbicide, you can expect superior broadleaf weed control that lasts in your wheat and barley.",
            buttonLabel: "Learn More",
            buttonLink: "/smoulder",
            productLogo: "/preseedherbicide/images/Smoulder_R.svg",
            productIcons:
                [
                    ["/preseedherbicide/images/Group_402.png", "Wheat/barley"],
                ],

            cropImage: "/preseedherbicide/images/CEREALS_13_summer_38074.png",
            cropImageAlt: "wheat growing in a field"
        },
        {
            heading: "Voraxor herbicide",
            description: "An enhanced pre-seed burndown that also takes advantage of residual suppression in peas, lentils, corn, soybeans, wheat and barley.",
            buttonLabel: "Learn More",
            buttonLink: "/voraxor",
            productLogo: "/preseedherbicide/images/Voraxor_R.svg",
            productIcons:
                [
                    ["/preseedherbicide/images/Group_398.png", "Peas"],
                    ["/preseedherbicide/images/Group_399.png", "Soybeans"],
                    ["/preseedherbicide/images/Group_400.png", "Lentils"],
                    ["/preseedherbicide/images/Group_401.png", "Corn"],
                    ["/preseedherbicide/images/Group_402.png", "Wheat/barley"],
                ],

            cropImage: "/preseedherbicide/images/LENTILS_AdobeStock_267814752.png",
            cropImageAlt: "lentil plant"
        }


    ],
    whyPreseed: {
        pictureTextFlexRow1: [
            {
                title: "Agronomic impact.",
                text: "<p>Weeds are well known for lowering crop yields by competing for important resources at critical growth stages. However, their presence can also impact the crop in a number of other ways. Weeds can act as alternate hosts for pests such as disease and insects. Later in the season, they can also cause harvest issues in your crop, potentially lowering the grade or value of your harvested grain.</p>",
                image_src: "/preseedherbicide/images/DIRT_iStock-183431727.png",
                image_alt: "N/A here",
                image_caption: ""
            },
        ],
        textFlexRow1: [
            {
                title: "Importance of a pre-seed application.",
                subtitle: "",
                text: "<p><div>Provides clean fields for the critical weed-free period</div><div>Smaller weeds for easier in-crop control</div><div>Can take advantage of multiple modes of effective action</div><div>Get the most out of your glyphosate with a tank mix</div></p>"
            },
            {
                title: "Return on investment (ROI).",
                subtitle: "",
                text: "<p>When you buy seed, you’re investing in genetics and performance. Without early-season weed control, you won’t be able to see the full potential of the crop you’ve invested in. A pre-seed herbicide application lowers the risk of losing yield potential (and profit) at the critical early stages of crop development. A pre-seed application can also help enhance the efficacy of in-crop herbicide applications, if needed.</p>"
            },
            {
                title: "Resistance management.",
                subtitle: "",
                text: "<p>Rotating and tank mixing chemistries is an important tool to delay the development of herbicide-resistant weed biotypes in your fields. Using multiple modes of action instead of glyphosate alone and applying when weeds are small promotes a more effective burndown and decreases the risk of herbicide-resistant biotypes.</p>",
            },

        ],
        textButtonBanner: [
            {
                title: "Scouting for weed seedlings.",
                text: "Weed seedlings can look very different from their mature forms. It’s important to know what weed seedling populations you have in your fields so that you can ensure you’re targeting them with the right products. Check out our Weed Seedling ID Guide to identify weed seedlings in your fields.",
                button_text: "Weed Seedling ID Guide",
                button_link: "/preseedherbicide/assets/Weed Seedling_ID Guide.pdf",

                cropImage: "/preseedherbicide/images/CANOLA_DSC_6615@2x.png",
                cropImageAlt: "weed seedling growing in a field"
            },
        ],
        banner: [
            {
                title: "Pre-seed herbicide options from BASF.",
                text: "BASF has a number of pre-seed herbicide options to cover off your crop, weed management and rotation needs. Check out the products below to see how they fit into your crop plans and provide effective, sustainable weed management to your fields.",
                links: [
                    ["/certitude", "Certitude"],
                    ["/smoulder", "Smoulder"],
                    ["/voraxor", "Voraxor"]
                ],
                image_src: "/preseedherbicide/images/videoTextCallout.png",
                image_alt: "a field of crops"
            },
        ],
    }
}

export const ConfigurationContext = React.createContext();

export const ConfigurationProvider = (props) => {

    const [config, update] = useState(initialState);

    //load the data from the config end point
    useEffect(() => {
        
        axios.get(`${constant.server_url}/preseedherbicide/api/configuration/get`)
            .then((result) => {
                processResult(result);
            }).catch((e) => {
                console.log(e);
            });
     
        

    }, []);
    
    const processResult = (result) => {
        let pin = getSiteParameter('PIN');
        if (result.data.success === true) {
            let res = JSON.parse(result.data.data)
            res.forEach(element => {
                element.selectedAnswer = {}
            });
            if(pin !== "")
            {
                axios.get(`${constant.server_url}/preseedherbicide/api/user/get/${pin}`)
                .then((result2) => {
                    let resData = JSON.parse(result2.data.data);
                    if(resData==null)
                    {
                        update({ ...config, questions: res });
                    }
                    else {
                      
                        update({ ...config, formData: resData , questions: res });
                    }
                   
                }).catch((e) => {
                    console.log(e);
                });

            }
            else {
                update({ ...config, questions: res })
            }
            

        }
    }

    return (
        <React.Fragment>
            {(config.loading) ?
                <Loading></Loading>
                :
                <ConfigurationContext.Provider value={[config, update]}>
                    {props.children}
                </ConfigurationContext.Provider>
            }
        </React.Fragment>
    );
}

function getSiteParameter(key) {
    var queryStr = decodeURIComponent(window.location.href);
    queryStr = queryStr.substring(queryStr.indexOf('&') + 1, queryStr.length);
    if (queryStr.toUpperCase().indexOf(key + "=") >= 0) {
        queryStr = queryStr.substring(queryStr.toUpperCase().indexOf(key + "=") + (key.length + 1), queryStr.length);
        if (queryStr.indexOf('#') >= 0) {
            queryStr = queryStr.substring(0, queryStr.indexOf('#')).split('&')[0];
        } else {
            queryStr = queryStr.split('&')[0];
        }

    } else {
        queryStr = "";
    }
    return queryStr;
 }




